import _ from "lodash";
import {messageActionType} from "_constants";
import {dispatcherActions, messageActions} from "_actions";
import {getPlatform} from "../../../Utilities/MessageDetailsUtils";

export function performAction(dispatch, actionType, message, params) {
    if(!actionType || !message) {
        return;
    }

    const messageId = _.get(message, 'id');
    const platform = getPlatform(messageId);

    switch (actionType) {
        case messageActionType.ACTION_MESSAGE:
            return dispatch(messageActions.tickMessageAsActioned([messageId], platform));

        case messageActionType.BLACKLIST_POST:
            return dispatch(dispatcherActions.blacklist(messageId, getMessageSource(message)));

        case messageActionType.DELETE_MESSAGE:
            return dispatch(dispatcherActions.deleteMessageFromSource(messageId, buildDeleteMessagePayload(message)));

        case messageActionType.HIDE_MESSAGE:
        case messageActionType.UNHIDE_MESSAGE:
            return dispatch(dispatcherActions.updateMessageFromSource(messageId, buildMessageVisibilityPayload(message, platform)));

        case messageActionType.LIKE_MESSAGE:
            return dispatch(dispatcherActions.likeMessageFromSource(messageId, getMessageSource(message)));

        case messageActionType.LOW_PRIORITY_MESSAGE:
        case messageActionType.HIGH_PRIORITY_MESSAGE:
            return dispatch(messageActions.changeMessagePracticePriority(messageId, !isReviewedStatus(message, params.updatedIsReviewed)));

        case messageActionType.UNDO_MESSAGE:
            return dispatch(messageActions.undoMessage(messageId));

        case messageActionType.CONSTRUCTIVE_FEEDBACK:
            params.constructiveFeedbackRef?.current?.open();
            break;

        case messageActionType.POSITIVE_FEEDBACK:
            params.positiveFeedbackRef?.current?.open();
            break;

        default:
            //do nothing
    }
}

export function isReviewed(msgIsReviewedInitialState, updatedIsReviewed) {
    if (updatedIsReviewed === undefined) {
        return msgIsReviewedInitialState
    } else {
        return updatedIsReviewed
    }
}

function buildDeleteMessagePayload(message) {
    const isV2Enabled = _.get(message, 'teamsAttributes.isV2Enabled') || _.get(message, 'isV2Enabled');
    const sourceName = _.get(message, 'sourceName') || _.get(message, 'msgDataSource.msgSource.name');
    return {
        isV2Enabled: isV2Enabled,
        source: sourceName
    }
}

function buildMessageVisibilityPayload(message, platform) {
    const hiddenFromSource = _.get(message, 'hiddenFromSource');
    const isV2Enabled = _.get(message, 'teamsAttributes.isV2Enabled') || _.get(message, 'isV2Enabled');
    const sourceName = _.get(message, 'sourceName') || _.get(message, 'msgDataSource.msgSource.name');
    return {
        updateFields: {
            is_hidden: (_.has(message, 'hiddenFromSource') ? !hiddenFromSource : true)
        },
        platform,
        isV2Enabled: isV2Enabled,
        source: sourceName
    }
}

function getMessageSource(message) {
    return _.get(message, 'sourceName') || _.get(message, 'msgDataSource.msgSource.name');
}

function isReviewedStatus(message, updatedIsReviewed) {
    return isReviewed(_.get(message, 'isReviewed'), updatedIsReviewed);
}